import { render, staticRenderFns } from "./salary-adjustment-modal.vue?vue&type=template&id=8ed75ddc&scoped=true"
import script from "./salary-adjustment-modal.vue?vue&type=script&lang=js"
export * from "./salary-adjustment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed75ddc",
  null
  
)

export default component.exports